import React from 'react';

const path = process.env.PUBLIC_URL

const Intro = () => {
  return (
    <div className="intro__container mt-0 md:mt-[2.5vh] rounded-tl-0 rounded-tr-0 md:rounded-tl-[20px] md:rounded-tr-[20px]">
      <h2><span>考前须知</span></h2>
      <div className="intro">
        <div className="intro__text">
        <p>为了节目能顺利播出，自我审查是各个中国媒体平台需要掌握的基本技能。对音乐综艺来说，让歌词符合播出标准至关重要。</p><p>你是一名热播音乐综艺审查员。以下是一些《乐队的夏天》和《乘风破浪的姐姐》中表演的歌曲，你需要审核与修改原歌词，达到播出标准。</p>
        </div>
      </div>
      <img src={`${path}/images/start.svg`} className="absolute w-[60px] top-[35px] right-[5px] z-10" />
      <img src={`${path}/images/eye2.svg`} className="absolute w-[120px] bottom-[10px] left-[50%] translate-x-[-50%] z-0" />
    </div>
  );
};

export default Intro;